import React, {useState} from 'react';
import { useMe } from "context/MeContext";
import { css } from '@emotion/react';
import { List } from "@pankod/refine-antd";
import "../../../App.scss"
import RouterProvider from "@pankod/refine-react-router-v6";
import { AdminCard } from 'components/AdminCard';
import { menuChat } from "./menu-chat.js"

const { Link } = RouterProvider;
export const MenuChat: React.FC = () => {

  return (
    <List title={<h1 style={{fontSize: 35, marginTop:20, color:"rgb(4, 6, 10, 0.8)"}}>Chat Center</h1>}>
      <div className="d2-grid" css={css`margin: 0 40px;`}>
        {/* card */}
        {menuChat.map((item, index) => (
          <AdminCard
            key={index}
            url={item.url}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </List>
  );
};
